/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var pastPrincipleByMonthColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name'
}, {
  name: 'Офис',
  value: 'office_name',
  sm: true
}, {
  name: 'Обща главница',
  render: function render(_ref) {
    var total_principal = _ref.total_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principal"
    }, total_principal, " ", currency);
  }
}, {
  name: 'Мес. 1',
  render: function render(_ref2) {
    var months = _ref2.months,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-1"
    }, months === null || months === void 0 ? void 0 : months['month-1'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -2',
  render: function render(_ref3) {
    var months = _ref3.months,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-2"
    }, months === null || months === void 0 ? void 0 : months['month-2'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -3',
  render: function render(_ref4) {
    var months = _ref4.months,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-3"
    }, months === null || months === void 0 ? void 0 : months['month-3'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -4',
  render: function render(_ref5) {
    var months = _ref5.months,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-4"
    }, months === null || months === void 0 ? void 0 : months['month-4'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -5',
  render: function render(_ref6) {
    var months = _ref6.months,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-5"
    }, months === null || months === void 0 ? void 0 : months['month-5'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -6',
  render: function render(_ref7) {
    var months = _ref7.months,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-6"
    }, months === null || months === void 0 ? void 0 : months['month-6'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -7',
  render: function render(_ref8) {
    var months = _ref8.months,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-7"
    }, months === null || months === void 0 ? void 0 : months['month-7'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -8',
  render: function render(_ref9) {
    var months = _ref9.months,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-8"
    }, months === null || months === void 0 ? void 0 : months['month-8'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -9',
  render: function render(_ref10) {
    var months = _ref10.months,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-9"
    }, months === null || months === void 0 ? void 0 : months['month-9'], " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Мес. -10',
  render: function render(_ref11) {
    var months = _ref11.months,
        currency = _ref11.currency;
    return ___EmotionJSX("span", {
      "data-value": "months.month-10"
    }, months === null || months === void 0 ? void 0 : months['month-10'], " ", currency);
  },
  invisibleBelow: 3000
}];